var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{class:{
    'sidebar-close': !_vm.getThemeMode.verticalSidebarDrawer,
  },style:({
    background: _vm.$vuetify.theme.themes[_vm.theme].background,
  })},[_c('app-bar'),_c('base-view'),_c('renew-token')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }